/**
 * Paletas de cores para diagramas Mermaid.
 * Ferrugini Advogados — tons calmos e profissionais para escritório de advocacia.
 */

export interface MermaidPaletteConfig {
  id: string;
  name: string;
  description: string;
  themeVariables: {
    primaryColor: string;
    primaryTextColor: string;
    primaryBorderColor: string;
    lineColor: string;
    secondaryColor: string;
    tertiaryColor: string;
    background: string;
    mainBkg: string;
    nodeBorder: string;
    clusterBkg: string;
    clusterBorder: string;
    titleColor: string;
    edgeLabelBackground: string;
    nodeTextColor: string;
    textColor: string;
  };
}

export const MERMAID_PALETTES: MermaidPaletteConfig[] = [
  {
    id: "ferrugini",
    name: "Ferrugini (padrão)",
    description: "Bordô e dourado — identidade do escritório",
    themeVariables: {
      primaryColor: "#D4AF37",
      primaryTextColor: "#000000",
      primaryBorderColor: "#5C0F17",
      lineColor: "#5C0F17",
      secondaryColor: "#5C0F17",
      tertiaryColor: "#f5f5f5",
      background: "#FFFFFF",
      mainBkg: "#FFFFFF",
      nodeBorder: "#5C0F17",
      clusterBkg: "#fafafa",
      clusterBorder: "#5C0F17",
      titleColor: "#000000",
      edgeLabelBackground: "#FFFFFF",
      nodeTextColor: "#000000",
      textColor: "#000000",
    },
  },
  {
    id: "azul",
    name: "Azul",
    description: "Azul marinho — sobriedade e confiança",
    themeVariables: {
      primaryColor: "#5B7A9E",
      primaryTextColor: "#000000",
      primaryBorderColor: "#2C4A6F",
      lineColor: "#2C4A6F",
      secondaryColor: "#2C4A6F",
      tertiaryColor: "#f0f4f8",
      background: "#FFFFFF",
      mainBkg: "#FFFFFF",
      nodeBorder: "#2C4A6F",
      clusterBkg: "#f8fafc",
      clusterBorder: "#2C4A6F",
      titleColor: "#000000",
      edgeLabelBackground: "#FFFFFF",
      nodeTextColor: "#000000",
      textColor: "#000000",
    },
  },
  {
    id: "cinza",
    name: "Cinza",
    description: "Cinza neutro — elegância discreta",
    themeVariables: {
      primaryColor: "#64748B",
      primaryTextColor: "#000000",
      primaryBorderColor: "#475569",
      lineColor: "#475569",
      secondaryColor: "#475569",
      tertiaryColor: "#f1f5f9",
      background: "#FFFFFF",
      mainBkg: "#FFFFFF",
      nodeBorder: "#475569",
      clusterBkg: "#f8fafc",
      clusterBorder: "#475569",
      titleColor: "#000000",
      edgeLabelBackground: "#FFFFFF",
      nodeTextColor: "#000000",
      textColor: "#000000",
    },
  },
  {
    id: "preto",
    name: "Preto",
    description: "Preto e dourado — sofisticação",
    themeVariables: {
      primaryColor: "#D4AF37",
      primaryTextColor: "#FFFFFF",
      primaryBorderColor: "#374151",
      lineColor: "#4B5563",
      secondaryColor: "#374151",
      tertiaryColor: "#1f2937",
      background: "#000000",
      mainBkg: "#0d0d0d",
      nodeBorder: "#4B5563",
      clusterBkg: "#111827",
      clusterBorder: "#4B5563",
      titleColor: "#FFFFFF",
      edgeLabelBackground: "#1f2937",
      nodeTextColor: "#FFFFFF",
      textColor: "#FFFFFF",
    },
  },
  {
    id: "prata",
    name: "Prata",
    description: "Prata e grafite — moderno e discreto",
    themeVariables: {
      primaryColor: "#94A3B8",
      primaryTextColor: "#000000",
      primaryBorderColor: "#64748B",
      lineColor: "#64748B",
      secondaryColor: "#64748B",
      tertiaryColor: "#f1f5f9",
      background: "#FFFFFF",
      mainBkg: "#FFFFFF",
      nodeBorder: "#64748B",
      clusterBkg: "#f8fafc",
      clusterBorder: "#64748B",
      titleColor: "#000000",
      edgeLabelBackground: "#FFFFFF",
      nodeTextColor: "#000000",
      textColor: "#000000",
    },
  },
  {
    id: "verde",
    name: "Verde",
    description: "Verde floresta — serenidade e equilíbrio",
    themeVariables: {
      primaryColor: "#4A7C59",
      primaryTextColor: "#000000",
      primaryBorderColor: "#2d4a3e",
      lineColor: "#2d4a3e",
      secondaryColor: "#2d4a3e",
      tertiaryColor: "#f0f7f2",
      background: "#FFFFFF",
      mainBkg: "#FFFFFF",
      nodeBorder: "#2d4a3e",
      clusterBkg: "#f8faf9",
      clusterBorder: "#2d4a3e",
      titleColor: "#000000",
      edgeLabelBackground: "#FFFFFF",
      nodeTextColor: "#000000",
      textColor: "#000000",
    },
  },
  {
    id: "rosa",
    name: "Rosa",
    description: "Rosa pó — delicadeza e acolhimento",
    themeVariables: {
      primaryColor: "#9F7A7A",
      primaryTextColor: "#000000",
      primaryBorderColor: "#7C5C5C",
      lineColor: "#7C5C5C",
      secondaryColor: "#7C5C5C",
      tertiaryColor: "#faf5f5",
      background: "#FFFFFF",
      mainBkg: "#FFFFFF",
      nodeBorder: "#7C5C5C",
      clusterBkg: "#fdf8f8",
      clusterBorder: "#7C5C5C",
      titleColor: "#000000",
      edgeLabelBackground: "#FFFFFF",
      nodeTextColor: "#000000",
      textColor: "#000000",
    },
  },
  {
    id: "laranja",
    name: "Laranja",
    description: "Âmbar — calor e profissionalismo",
    themeVariables: {
      primaryColor: "#B45309",
      primaryTextColor: "#000000",
      primaryBorderColor: "#92400E",
      lineColor: "#92400E",
      secondaryColor: "#92400E",
      tertiaryColor: "#fff7ed",
      background: "#FFFFFF",
      mainBkg: "#FFFFFF",
      nodeBorder: "#92400E",
      clusterBkg: "#fffbeb",
      clusterBorder: "#92400E",
      titleColor: "#000000",
      edgeLabelBackground: "#FFFFFF",
      nodeTextColor: "#000000",
      textColor: "#000000",
    },
  },
];

export const DEFAULT_PALETTE_ID = "ferrugini";

export function getPaletteById(id: string): MermaidPaletteConfig {
  return MERMAID_PALETTES.find((p) => p.id === id) ?? MERMAID_PALETTES[0];
}
